<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
    import { FITZPATRICK_TYPE_OPTIONS } from '../types/fitzpatrick-scale'

    export let data: Record<string, any>
</script>

<div class="fitz-scale">
    {#each FITZPATRICK_TYPE_OPTIONS as option (option.key)}
        <div class="fitz-row" class:selected={option.key === 'III'}>
            <span class="fitz-type">
                <span class="fitz-swatch" style="background-color: {option.swatch}"></span>
                {option.label}
                <span class="fitz-tooltip-icon"><Fa icon={faCircleQuestion} /></span>
            </span>
            <span class="fitz-desc">{option.description}</span>
        </div>
    {/each}
</div>

<style>
    .fitz-scale {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
    .fitz-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 10px 14px;
        border-radius: 8px;
        background: #f8f9fa;
    }
    .fitz-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .fitz-type {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .fitz-row.selected .fitz-type {
        color: #1f2937;
    }
    .fitz-swatch {
        width: 20px;
        height: 20px;
        border-radius: 5px;
        flex-shrink: 0;
        box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.12);
    }
    .fitz-desc {
        flex: 1;
        min-width: 0;
        text-align: right;
        font-size: 0.85rem;
        color: #495057;
    }
    .fitz-row.selected .fitz-desc {
        color: #1f2937;
    }
    .fitz-tooltip-icon {
        font-size: 0.72rem;
        color: #adb5bd;
    }
    .fitz-row.selected .fitz-tooltip-icon {
        color: #1f2937;
        opacity: 0.75;
    }
</style>
